import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";
import type { SvgIconProps } from "@mui/material";
import { IconButton } from "@mui/material";
import type { ComponentType } from "react";

interface Props {
  expanded: boolean;
  onClick: (expanded: boolean) => void;
}

export function ExpandCollapseButton({ expanded, onClick }: Props) {
  return expanded ? (
    <ExpandCollapseButtonControl Icon={ArrowDropDownRoundedIcon} onClick={() => onClick(false)} />
  ) : (
    <ExpandCollapseButtonControl Icon={ArrowRightRoundedIcon} onClick={() => onClick(true)} />
  );
}

function ExpandCollapseButtonControl({ Icon, onClick }: { Icon: ComponentType<SvgIconProps>; onClick: () => void }) {
  return (
    <IconButton onClick={onClick}>
      <Icon sx={{ color: "secondary.main" }} />
    </IconButton>
  );
}
